var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 41,
    viewBox: "0 0 120 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.011 6.82045C108.97 7.08898 108.95 7.33066 108.95 7.54548C108.95 7.89457 109.031 8.17653 109.192 8.39135C109.353 8.60618 109.682 8.71359 110.179 8.71359H111.77C112.092 8.71359 112.36 8.6666 112.575 8.57261C112.79 8.4652 112.965 8.32422 113.099 8.14967C113.247 7.97513 113.361 7.77373 113.441 7.54548C113.522 7.31723 113.582 7.07556 113.623 6.82045L114.287 3.03418H119.06L118.013 8.93513C117.932 9.36477 117.731 9.80114 117.409 10.2442C117.1 10.6873 116.731 11.0834 116.301 11.4325C115.871 11.7815 115.422 12.0702 114.952 12.2985C114.482 12.5133 114.052 12.6207 113.663 12.6207H112.676L112.052 16.1653H107.278L107.903 12.6207H106.916C106.567 12.6207 106.204 12.5267 105.828 12.3387C105.466 12.1508 105.13 11.9024 104.821 11.5936C104.526 11.2713 104.284 10.9155 104.096 10.5262C103.908 10.1368 103.814 9.74072 103.814 9.33792C103.814 9.27079 103.814 9.20366 103.814 9.13652C103.828 9.06939 103.841 9.00226 103.855 8.93513L104.902 3.03418H109.675L109.011 6.82045Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0535 3.03418H103.446L102.742 6.98157H98.4317L96.8205 16.1653H92.0474L93.6585 6.98157H89.3486L90.0535 3.03418Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6022 16.1653H72.8291L75.1452 3.03418H85.356C85.732 3.03418 86.0945 3.12817 86.4436 3.31614C86.7927 3.50411 87.1015 3.7525 87.37 4.06131C87.652 4.35669 87.8735 4.69907 88.0346 5.08843C88.1957 5.46438 88.2763 5.85374 88.2763 6.25654C88.2763 6.3371 88.2696 6.41766 88.2562 6.49822C88.2562 6.57878 88.2494 6.65933 88.236 6.73989L88.0145 7.908C87.9339 8.37793 87.7929 8.83443 87.5915 9.2775C87.3901 9.72058 87.1216 10.1301 86.7859 10.506C86.4637 10.882 86.0743 11.2176 85.6178 11.513C85.1613 11.8084 84.6377 12.0434 84.0469 12.2179H89.4041L88.6992 16.1653H80.9857C80.6232 16.125 80.2875 15.9706 79.9787 15.7021C79.6699 15.4201 79.3947 15.0845 79.153 14.6951C78.9113 14.3057 78.7166 13.8962 78.5689 13.4666C78.4212 13.0235 78.3273 12.6207 78.287 12.2582L77.6022 16.1653ZM78.9314 8.57261H81.6705C82.1135 8.57261 82.4559 8.51219 82.6976 8.39135C82.9393 8.27051 83.0937 8.06912 83.1608 7.78716V7.66632C83.1608 7.20982 82.758 6.98157 81.9524 6.98157H79.2134L78.9314 8.57261Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6853 11.3318H64.8377L64.6968 12.2179H72.088L71.3832 16.1653H59.2188L61.5348 3.03418H73.6992L72.9943 6.98157H65.6031L65.4621 7.86772H72.3096L71.6853 11.3318Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3707 7.20311C59.3305 7.43136 59.2566 7.65289 59.1492 7.86772C59.0418 8.08254 58.9142 8.29065 58.7666 8.49205C58.6323 8.68002 58.4779 8.86128 58.3033 9.03582C58.1422 9.21037 57.9878 9.35806 57.8401 9.4789C58.0281 9.74743 58.1959 10.063 58.3436 10.4255C58.5047 10.788 58.5853 11.1706 58.5853 11.5734C58.5853 11.6406 58.5786 11.7077 58.5652 11.7748C58.5652 11.842 58.5584 11.9091 58.545 11.9762L58.5047 12.2179C58.4242 12.6878 58.2228 13.1578 57.9005 13.6277C57.5917 14.0842 57.2158 14.5071 56.7727 14.8965C56.3296 15.2724 55.8463 15.5812 55.3227 15.8229C54.8125 16.0512 54.309 16.1653 53.8122 16.1653H43.6416L45.9577 3.03418H56.1282C56.5848 3.03418 57.0144 3.13488 57.4172 3.33628C57.82 3.53767 58.1691 3.79949 58.4645 4.12173C58.7733 4.44396 59.0149 4.81319 59.1895 5.22941C59.364 5.64563 59.4513 6.06857 59.4513 6.49822C59.4513 6.57878 59.4446 6.65933 59.4312 6.73989C59.4312 6.82045 59.4245 6.90101 59.411 6.98157L59.3707 7.20311ZM50.046 6.98157L49.8849 7.88786H53.3892C53.7786 7.88786 54.0404 7.85429 54.1747 7.78716C54.3224 7.72003 54.4097 7.61262 54.4365 7.46492L54.4566 7.34409C54.4566 7.19639 54.3828 7.10241 54.2351 7.06213C54.0874 7.00842 53.8592 6.98157 53.5504 6.98157H50.046ZM49.2807 11.3116L49.1398 12.2179H52.6441C53.02 12.2179 53.2751 12.1843 53.4094 12.1172C53.5571 12.0366 53.6443 11.9225 53.6712 11.7748C53.6846 11.7614 53.6913 11.7144 53.6913 11.6339C53.6913 11.4996 53.6242 11.4123 53.4899 11.372C53.3691 11.3318 53.1341 11.3116 52.785 11.3116H49.2807Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1999 16.1653H37.4268L39.7428 3.03418H44.5159L42.1999 16.1653Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16.1653L28.3161 3.03418H33.0892L31.478 12.2179H36.6741L35.9692 16.1653H26Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.28 33.2839H65.5068L67.8229 20.1528H77.9935C78.45 20.1528 78.8796 20.2535 79.2824 20.4549C79.6852 20.6563 80.0343 20.9249 80.3297 21.2605C80.6385 21.5962 80.8802 21.9721 81.0547 22.3883C81.2293 22.8046 81.3165 23.2275 81.3165 23.6571C81.3165 23.7377 81.3098 23.8183 81.2964 23.8988C81.2964 23.9794 81.2897 24.0599 81.2763 24.1405L80.9943 25.7315C80.9137 26.1746 80.7123 26.6378 80.3901 27.1212C80.0679 27.5911 79.6785 28.0208 79.222 28.4101C78.7789 28.7995 78.2956 29.1217 77.7719 29.3768C77.2617 29.6185 76.7717 29.7394 76.3017 29.7394H70.9043L70.28 33.2839ZM71.589 25.8524H74.8315C75.3283 25.8524 75.6707 25.7785 75.8587 25.6308C76.0466 25.4832 76.1742 25.2683 76.2413 24.9864L76.2615 24.785C76.2615 24.5701 76.1876 24.4023 76.0399 24.2815C75.8922 24.1606 75.5901 24.1002 75.1336 24.1002H71.8911L71.589 25.8524Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3991 31.27H54.5253L53.4781 33.2839H48.564L54.9885 20.1528H62.6417L64.4341 33.2839H59.7214L59.3991 31.27ZM56.1969 27.7657H58.9561L58.3116 23.6169L56.1969 27.7657Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1282 25.1273L47.7061 20.1528H52.6202L46.1956 33.2839H41.4426L40.9391 28.108L38.6231 33.2839H33.8701L32.0776 20.1528H36.7903L37.5355 25.1273L40.1335 20.1528H44.3629L45.1282 25.1273Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15 33.2839L15.7049 29.3366H22.2302C21.9214 28.9338 21.579 28.5175 21.203 28.0879C20.8405 27.6582 20.4982 27.2152 20.1759 26.7587C19.8537 26.2887 19.5717 25.8054 19.33 25.3086C19.1018 24.8118 18.9675 24.3016 18.9273 23.778V23.6571C18.9273 23.5229 18.9474 23.3618 18.9877 23.1738C19.0682 22.7441 19.2159 22.3481 19.4307 21.9855C19.659 21.6096 19.9275 21.2874 20.2363 21.0188C20.5451 20.7503 20.8875 20.5422 21.2635 20.3945C21.6394 20.2334 22.0221 20.1528 22.4114 20.1528H31.0111L30.3062 24.1002H24.6067C24.9558 24.597 25.3116 25.0736 25.6741 25.5301C26.05 25.9866 26.3924 26.4499 26.7012 26.9198C27.01 27.3763 27.2584 27.8462 27.4464 28.3296C27.6478 28.8129 27.7485 29.3231 27.7485 29.8602C27.7485 30.1019 27.7283 30.3503 27.688 30.6054C27.6209 30.9947 27.4934 31.3505 27.3054 31.6728C27.1174 31.995 26.8892 32.277 26.6206 32.5186C26.3521 32.7603 26.0433 32.9483 25.6942 33.0826C25.3585 33.2168 25.0027 33.2839 24.6268 33.2839H15Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11046_1819)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49273 27.3762C1.79487 28.243 1.11013 29.1723 1.23631 31.6059L1.67908 40.0341L6.75031 25.8936L3.49256 27.3764L3.49273 27.3762Z",
    fill: "url(#paint0_linear_11046_1819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9599 15.3239L4.7258 13.131C4.14594 12.9745 4.28285 12.5458 4.62038 12.4832C3.18667 12.4625 1.39396 13.4337 0.645513 14.6768C0.149952 15.4912 0.128835 16.6505 1.01437 17.3923C1.33078 17.6534 1.74187 17.8726 2.25855 18.0291L7.49819 19.6272L13.3814 17.0475C14.0878 16.6922 13.7608 15.5955 12.9596 15.3241L12.9599 15.3239Z",
    fill: "url(#paint1_linear_11046_1819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23605 31.6062C1.20437 29.7262 1.82681 28.4104 3.53453 27.5438L6.75004 25.8938L13.3604 22.4993C14.3725 21.946 14.8045 21.0686 14.8045 19.9611V17.6426C14.8045 16.4417 14.3195 15.6793 13.2018 15.3866L12.9597 15.3242C13.5816 15.5646 13.5816 16.515 12.8754 16.87L7.49831 19.6273L3.63976 21.6115C1.53134 22.6871 0.82478 24.1077 0.961693 26.4264L1.23587 31.6062H1.23605Z",
    fill: "url(#paint2_linear_11046_1819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63565 22.4992L2.78616 24.9847C1.43674 25.6742 1.00418 26.4262 1.04677 27.9509L1.2363 31.6062C1.20462 29.7262 1.82707 28.4104 3.53478 27.5438L13.3608 22.4993C14.3729 21.946 14.8049 21.0686 14.8049 19.9611V17.6426C14.8049 18.6769 14.1304 19.1676 13.2971 19.5959L9.2911 21.643C9.45987 20.891 9.54434 20.0349 9.51231 19.314C9.10122 20.964 8.14177 22.8647 7.09821 24.2227C7.30903 23.6586 7.48836 23.0842 7.63583 22.4993L7.63565 22.4992Z",
    fill: "url(#paint3_linear_11046_1819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8047 19.9609C14.773 21.0057 14.0138 21.6531 13.1598 22.1231L3.32355 27.1467C1.65789 28.003 1.13065 29.3504 1.21513 31.1569L1.23607 31.606C1.20439 29.726 1.82683 28.4102 3.53455 27.5436L13.3606 22.4991C14.3727 21.9458 14.8047 21.0684 14.8047 19.9609Z",
    fill: "url(#paint4_linear_11046_1819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64181 12.4832C5.74855 12.2955 6.91864 12.3059 7.99406 12.3582C11.0097 12.5148 14.5625 12.9635 17.63 12.1907C20.0554 11.5643 22.1637 10.1647 22.7435 7.63762C22.2166 8.50437 20.593 9.56986 19.3383 9.73669C17.5776 9.96663 17.3142 8.13864 18.8744 7.61688C19.9394 7.2616 20.9091 7.0735 21.8476 6.72938C24.926 5.61159 26.4127 3.33488 25.9699 0.0341797C25.369 1.98716 23.8506 2.93794 21.9111 3.19874C19.644 3.52246 16.9875 3.12569 15.0474 3.59585C14.4571 3.73165 13.9508 3.98233 13.3817 4.44151C14.7624 3.12569 15.4688 2.60358 17.0819 2.15434C12.9808 1.80987 3.78725 6.37375 0.814584 12.118C-0.113712 13.9352 -0.492774 16.17 1.01467 17.3924C0.234377 16.7131 0.329406 15.5852 0.825143 14.7601C1.57376 13.507 3.22904 12.7241 4.64198 12.4834L4.64181 12.4832Z",
    fill: "url(#paint5_linear_11046_1819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7345 3.79441C22.891 5.74705 19.6651 5.93532 18.0096 6.80172C16.3647 7.66883 16.3862 9.83048 18.3998 9.8514C18.8322 9.8514 19.2748 9.76824 19.6545 9.67411C19.5491 9.70531 19.4433 9.72641 19.3379 9.73669C17.5772 9.96663 17.3138 8.13864 18.874 7.61688C19.9391 7.2616 20.9087 7.0735 21.8472 6.72938C24.9257 5.61159 26.4123 3.33488 25.9696 0.0341797C25.3686 1.98716 23.8502 2.93794 21.9108 3.19874C19.6436 3.52246 16.9872 3.12569 15.047 3.59585C14.4568 3.73165 13.9505 3.98233 13.3813 4.44151C15.8166 2.82306 20.1392 5.30861 23.7343 3.79441H23.7345Z",
    fill: "url(#paint6_linear_11046_1819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01528 11.7834C6.89745 11.7314 5.68513 11.7314 4.53597 11.9613C2.97555 12.264 1.25711 13.1414 0.550719 14.6245C0.192247 15.3656 0.107953 16.3788 0.666691 17.0578C0.761896 17.1727 0.877691 17.2877 1.0146 17.3923C0.234307 16.713 0.329336 15.5851 0.825073 14.76C1.57369 13.5069 3.22897 12.724 4.64191 12.4833C5.74865 12.2955 6.91875 12.306 7.99416 12.3583C11.0098 12.5148 14.5626 12.9636 17.6302 12.1908C20.0555 11.5644 22.1638 10.1647 22.7436 7.6377C22.1006 10.0397 19.7602 11.2825 17.4723 11.7523C14.4572 12.3583 11.0728 11.9511 8.01546 11.7835L8.01528 11.7834Z",
    fill: "url(#paint7_linear_11046_1819)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43816 11.857C4.34632 9.78915 6.54995 9.48617 8.39493 9.37146C9.62855 9.29807 11.2203 9.38192 12.38 8.80734C14.0353 7.9819 14.4782 5.62169 16.7447 5.86191C15.5429 5.36055 14.0251 5.61158 12.7489 6.48862C10.9987 7.75214 9.82864 5.85146 11.3678 4.81787C8.26822 6.05019 4.36726 8.84918 2.43799 11.8568L2.43816 11.857Z",
    fill: "url(#paint8_linear_11046_1819)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11046_1819",
    x1: 3.986,
    y1: 25.3249,
    x2: 3.986,
    y2: 40.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C20067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF644B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11046_1819",
    x1: 0.233543,
    y1: 16.0548,
    x2: 15.2394,
    y2: 16.0548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C20067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF644B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11046_1819",
    x1: 17.0569,
    y1: 23.4651,
    x2: -4.63589,
    y2: 23.4651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C20067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF644B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11046_1819",
    x1: 19.9875,
    y1: 24.6244,
    x2: -1.41027,
    y2: 24.6244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C20067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF644B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11046_1819",
    x1: 22.7243,
    y1: 25.7835,
    x2: 0.566989,
    y2: 25.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C20067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF644B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11046_1819",
    x1: -1.79873,
    y1: 8.71322,
    x2: 28.9069,
    y2: 8.71322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E61C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ED8023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FF79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11046_1819",
    x1: -3.39064,
    y1: 4.9427,
    x2: 27.3151,
    y2: 4.9427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E61C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ED8023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FF79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11046_1819",
    x1: -2.3292,
    y1: 12.5148,
    x2: 24.095,
    y2: 12.5148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E61C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ED8023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FF79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11046_1819",
    x1: -2.89844,
    y1: 8.33753,
    x2: 19.8516,
    y2: 8.33753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E61C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ED8023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FF79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11046_1819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0465,
    height: 40,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4153cb3011909c3b15612a9aebd32f3d.svg";
export { ForwardRef as ReactComponent };